/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcrs } from '../../pcr/store/pcr.types'
import { getServiceIdSelector, getUserIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../selectors'
import { applyFilter, setPcrList } from '../store/home.actions'
import Logger from '../../../services/logger.service'
import { HomeConstants } from '../store/home.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* deletePCR() {
  const serviceId: string = yield select(getServiceIdSelector)
  const userId: string = yield select(getUserIdSelector)
  const pcrId: string = yield select(getPcrIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  try {
    yield call([pcrDocsService, pcrDocsService.deletePcrDoc], pcrId, userId)
    Logger.info(`PCR: ${pcrId} deleted by user: ${userId} in service: ${serviceId}`)

    const pcrDocs: IPcrs = yield call([pcrDocsService, pcrDocsService.getPCRDocsPerUser], userId)
    yield put(setPcrList(pcrDocs))
    yield put(applyFilter())
  } catch (e) {
    yield put(throwPcrException(`deletePCR() error: ${e}`))
  }
}

export function* deletePCRSaga() {
  yield takeLatest([HomeConstants.DELETE_PCR], performWithMutexHOG, deletePCR)
}
